import {hiddenFieldTypes} from '../../constants/FieldConsts';
import {design} from '../../constants/ScreenTypes';
import {getCompressedDataSet, getLanguage} from '../../_shared/GWTBridge/invoke/common';
import {
    getConnection,
    getUsername,
    getHomepageEntities
} from '../../_shared/GWTBridge/invoke/genPage';
import texts from '../Personalization/texts';
import {sendMonitor} from '../../utils/monitoring';
import {showSuccessToast} from '../../components/Toast/actions/ToastActions';
import {Search} from '../../_legacy/Searches/stores/Search';
import {Form} from '../../_legacy/Form/stores/Form';
import {
    PersonalizationSearches,
    IndexedSearch
} from '../../services/indexDB/indexeddbServiceSearches';
import Cookies from 'js-cookie';

import {
    endFormDesign,
    getFieldDesignDataSet,
    showFormDesignPanel
} from '../../_shared/GWTBridge/invoke/netForm';
import {getStateXml} from '../../_shared/GWTBridge/invoke/server';
import {buildFormServerCall} from '../../_legacy/services/formService';
import {
    getSubFormsSuggestion,
    configuration as formsConf,
    db as subformsDB
} from '../../services/indexDB/indexeddbServiceSubForms';

import {
    getActionSuggestion,
    configuration as actionsConf,
    db as actionsDB
} from '../../services/indexDB/indexeddbServiceActions';

import {
    checkEntitySuggestion,
    configuration as homepageConf,
    db as homepageDB,
    startNewCollection as homepageNewCollection
} from '../../services/indexDB/indexeddbService';

import {
    removeNeverShowAgainIndexedDB,
    setNeverShowAgainIndexedDB,
    addToBlackList,
    startNewCollection
} from './service/indexDBService';

import {updateCollectionDate, saveNewSearch} from './service/indexDBSearchesService';
import {addSearchToServerBlacklist} from './service/searchesBlacklistService';

import {getBasicUserData, PersonalizationType, getSearchFilters} from './utils/personalization';
import {configuration as baseConfiguration} from './config';

import {isDevEnv} from '../../utils/platform';
import {getStorageItem, setStorageItem} from '../../services/storageService';
import {buildServerCall} from '../../services/wcfService';
import {BLACKLIST_KEY} from './service/searchesBlacklistService';
import {
    db as moreInfoDB,
    getCollectionPeriodData
} from '../../services/indexDB/indexeddbServiceZoomedScreens';
import {BLACKLIST_KEY as moreInfoBlacklist} from './service/moreInfoBlacklistService';
import {addScreenToServerBlacklist} from './service/moreInfoBlacklistService';
import {updateUserPrevIndexed} from './service/moreInfoPrevIndexed';
import {PREV_INDEXED_KEY} from './service/moreInfoPrevIndexed';
import {
    addSoonzedSuggestion,
    resetPersonalizationSuggestion
} from '../../services/indexDB/indexeddbPersonalizationCenter';
import {SuggestionType} from './types/personalizationCenter';
import {personalizationDialogRef} from './components/PersonalizationDialog.root';
import {personalizationSearchesDialogRef} from './components/PersonalizationSearchesDialog.root';
import {addTileFromMenu} from '../Homepage/actions/dialogs';
import {isAutomation} from '../FeaturePopover/actions/feature';

export const openDesignPanel = (db, parentForm, type) => {
    const pType = PersonalizationType.Actions === type ? 'A' : 'S';

    if (PersonalizationType.Actions === type) {
        sendMonitor('Action_recommend_design');
    } else if (PersonalizationType.SubForms === type) {
        sendMonitor('recommend_design');
    }

    showFormDesignPanel(pType);
    startNewCounting(db, parentForm, type);
};

export const startNewCounting = (db, formName, type, skipMonitor?) => {
    if (PersonalizationType.Actions === type) {
        if (!skipMonitor) {
            sendMonitor('PersonalizationActionLater');
        }

        startNewCollection(db, formName, baseConfiguration);
    } else if (PersonalizationType.SubForms === type) {
        if (!skipMonitor) {
            sendMonitor('PersonalizationSLFLater');
        }

        startNewCollection(db, formName, baseConfiguration);
    } else if (PersonalizationType.Homepage === type) {
        if (!skipMonitor) {
            sendMonitor('PersonalizationHPLater');
        }

        homepageNewCollection();
    }
};

export const hideItem = async (entity, isSnoozed) => {
    await addToBlackList(entity.name, homepageDB, entity.type);
    await showHomepageSuggestion(true, isSnoozed);

    const forms = getHomepageEntities();
    const data: any = await getDataByType(PersonalizationType.Homepage, '', forms, isSnoozed);

    if (!data.length) {
        if (!isSnoozed) {
            homepageNewCollection();
        } else {
            await resetPersonalizationSuggestion(SuggestionType.Homepage);
        }
    }
};

export const personalize = async (
    type: PersonalizationType,
    entity: any,
    entities?,
    isSnoozed?: boolean
) => {
    switch (type) {
        case PersonalizationType.SubForms:
            sendMonitor('PersonalizationSLFHide');
            await hideSubForms(entity, entities);
            return await resetPersonalizationSuggestion(SuggestionType.Subforms);
        case PersonalizationType.Actions:
            sendMonitor('PersonalizationActionHide');
            await moveActionsToFront(entity, entities);
            return await resetPersonalizationSuggestion(SuggestionType.Actions);
        case PersonalizationType.Homepage:
            sendMonitor('PersonalizationHPAdd');
            addTileFromMenu(entity.exec, entity.title);
            homepageConf.maxEntities = --homepageConf.maxEntities;
            isDoneEnabled = true;
            await hideItem(entity, isSnoozed);

            return showSuccessToast(`${texts.addedToHomepage.replace('X', entity.title)}`);
        default:
            return [];
    }
};

export const hideSubForms = async (formName: string, formsToHide?) => {
    const data: any = await getScreensData();

    const list = data?.Form[0]?.ADesigns[0].ADesign;
    const subFormNames = formsToHide.map(({name}) => {
        return name;
    });
    if (list) {
        list.forEach(subForm => {
            if (subFormNames.includes(subForm.zoomname)) {
                subForm.hidden = hiddenFieldTypes.HIDDEN;
            }
        });

        const ds = getFieldDesignDataSet(design.SUBLEVELS, list);
        const dsXML = getCompressedDataSet(ds);
        await setScreensData(dsXML, design.SUBLEVELS);
        endFormDesign(ds, design.SUBLEVELS);
        startNewCounting(subformsDB, formName, PersonalizationType.SubForms, true);
    }
};

export const moveActionsToFront = async (formName: string, selectedItems?) => {
    const actions: any = await getActionsData();
    const actionsList = actions?.Form[0]?.ADesigns?.[0].ADesign;

    selectedItems?.forEach(selectedItem => {
        const index = actionsList.findIndex(item => item.zoomname === selectedItem.name);

        if (selectedItem.keepButton) {
            const temp = actionsList[index];
            actionsList[index] = actionsList[0];
            actionsList[0] = temp;
        } else {
            const aItem = actionsList.splice(index, 1)[0];
            actionsList.unshift(aItem);
        }
    });

    const ds = getFieldDesignDataSet(design.ACTIVATIONS, actionsList);
    const dsXML = getCompressedDataSet(ds);
    await setScreensData(dsXML, design.ACTIVATIONS);

    endFormDesign(ds, design.ACTIVATIONS);
    startNewCounting(actionsDB, formName, PersonalizationType.Actions, true);
};

export const showActionsSuggestions = async (
    formName: string,
    activations = [],
    isSnoozed = false
) => {
    const data: any = await getDataByType(
        PersonalizationType.Actions,
        formName,
        activations,
        isSnoozed
    );

    const actionsTexts = {
        upperTitle: texts.upperTitle,
        itemsSubTitle: texts.upperTitleActionsContinue,
        selectAll: texts.subForms_selectAll,
        hide: texts.yesReorder,
        design: texts.orderMyself,
        neverShowAll: texts.subForms_neverShowAll,
        snooze: texts.subForms_snooze,
        successOk: texts.subForms_success_ok,
        successContent: texts.actionsMoreInfo,
        successTitle: texts.actionsUpdated
    };

    if (data.length > 0) {
        const displayDialog = isSnoozed || showDialog();
        if (!displayDialog) return;
        !isSnoozed && sendMonitor('Show Action Rec');

        personalizationDialogRef.current.showDialog({
            type: PersonalizationType.Actions,
            items: data,
            db: actionsDB,
            configuration: actionsConf,
            texts: actionsTexts,
            showEntityIcon: true,
            isSnoozed
        });
    }
};

export const showSubFormsSuggestion = async (
    formName: string,
    subForms = [],
    isSnoozed = false
) => {
    const data: any = await getDataByType(
        PersonalizationType.SubForms,
        formName,
        subForms,
        isSnoozed
    );

    const formTexts = {
        upperTitle: texts.upperTitle,
        itemsSubTitle: texts.subForms_subTitle,
        selectAll: texts.subForms_selectAll,
        hide: texts.subForms_hide,
        design: texts.subForms_design,
        neverShowAll: texts.subForms_neverShowAll,
        snooze: texts.subForms_snooze,
        successContent: texts.subForms_success_content,
        successTitle: texts.subForms_success_title,
        successOk: texts.subForms_success_ok
    };

    if (data?.length > 0 && subForms.length > 1) {
        const displayDialog = isSnoozed || showDialog();
        if (!displayDialog) return;
        !isSnoozed && sendMonitor('Show Subforms Rec');

        personalizationDialogRef.current.showDialog({
            type: PersonalizationType.SubForms,
            items: data,
            db: subformsDB,
            configuration: formsConf,
            texts: formTexts,
            showEntityIcon: false,
            isSnoozed
        });
    }
};

let isDoneEnabled = false;
export const showHomepageSuggestion = async (
    isRefresh: boolean = false,
    isSnoozed: boolean = false
) => {
    const forms = getHomepageEntities();
    const data: any = await getDataByType(PersonalizationType.Homepage, '', forms, isSnoozed);

    const formTexts = {
        upperTitle: texts.upperTitle,
        itemsSubTitle: texts.personalizeHomepageDescription,
        dontShowAgain: texts.dontShowAgain,
        add: texts.add,
        done: texts.done,
        snooze: texts.subForms_snooze,
        neverShowAll: texts.subForms_neverShowAll
    };

    if (data?.length > 0) {
        const displayDialog = isSnoozed || showDialog();
        if (!isDoneEnabled && !displayDialog) return;

        !isSnoozed && sendMonitor('Show homepage Rec');

        personalizationDialogRef?.current?.showDialog({
            type: PersonalizationType.Homepage,
            items: data,
            db: homepageDB,
            configuration: homepageConf,
            texts: formTexts,
            isRefresh: isRefresh,
            isDoneEnabled: isDoneEnabled,
            isSnoozed
        });
    } else {
        personalizationDialogRef?.current?.handleClose();
    }
};

export const showSearchesSuggestion = (
    db: PersonalizationSearches,
    search: Search,
    form: Form,
    popularSearch: IndexedSearch
) => {
    if (!showDialog()) return;
    const basicUserData = getBasicUserData();
    const formName = form.name;
    const user = {...basicUserData, formName};

    const handleSnooze = async () => {
        sendMonitor('PersonalizationSearchLater');
        updateCollectionDate(db);
        addSoonzedSuggestion({
            type: SuggestionType.Searches,
            reference: formName,
            lang: getLanguage(),
            search: popularSearch
        });
        personalizationSearchesDialogRef.current.handleClose();
    };

    const handleReject = async () => {
        sendMonitor('PersonalizationSearchDont');
        await addSearchToServerBlacklist(formName, popularSearch);
        updateCollectionDate(db);
        personalizationSearchesDialogRef.current.handleClose();
    };

    const handleSaveSearch = async (name, isDefault) => {
        sendMonitor('PersonalizationSearchSave');
        await saveNewSearch(search, name, isDefault);
        await addSearchToServerBlacklist(formName, popularSearch);
        updateCollectionDate(db);
        personalizationSearchesDialogRef.current.handleClose();
    };

    const monitorNameChange = () => {
        sendMonitor('PersonalizationSearchName');
    };

    personalizationSearchesDialogRef.current.showDialog({
        db,
        search,
        form,
        popularSearch,
        user,
        handleSnooze,
        handleReject,
        handleSaveSearch,
        monitorNameChange
    });
};

export const showSnoozedSearchesSuggestion = (form: Form, popularSearch: IndexedSearch) => {
    const handleSnooze = () => {
        sendMonitor('PersonalizationSearchLater');
        personalizationSearchesDialogRef.current.handleClose();
    };

    const handleReject = async () => {
        sendMonitor('PersonalizationSearchDont');
        await addSearchToServerBlacklist(form.name, popularSearch);
        resetPersonalizationSuggestion(SuggestionType.Searches);
        personalizationSearchesDialogRef.current.handleClose();
    };

    const handleSaveSearch = async (name, isDefault) => {
        sendMonitor('PersonalizationSearchSave');
        const searchFilters = getSearchFilters(form, popularSearch.filters);
        const search = new Search(form.searches, null, searchFilters);
        await saveNewSearch(search, name, isDefault);
        await addSearchToServerBlacklist(form.name, popularSearch);
        resetPersonalizationSuggestion(SuggestionType.Searches);
        personalizationSearchesDialogRef.current.handleClose();
    };

    const monitorNameChange = () => {
        sendMonitor('PersonalizationSearchName');
    };

    personalizationSearchesDialogRef.current.showDialog({
        db: null,
        search: null,
        form,
        popularSearch,
        user: null,
        handleSnooze,
        handleReject,
        handleSaveSearch,
        monitorNameChange
    });
};

export const showDialog = (): boolean => {
    if (isAutomation()) {
        return false;
    }
    const cookieName = `${baseConfiguration.cookieKey}${getUsername()}`;
    let appearances = Cookies.get(cookieName) || 0;
    appearances = Number(appearances);

    if (appearances >= baseConfiguration.maxAppearances) {
        return false;
    } else if (!isDevEnv()) {
        const day = new Date().getDay();
        if (getLanguage() === 1 && day === 0) return false; // Don't show personalization on Sundays in Hebrew language
        if (getLanguage() !== 1 && day === 1) return false; // Don't show personalization on Monday in non Hebrew language
    }
    Cookies.set(cookieName, appearances + 1, {expires: 10});
    return true;
};

export const getDataByType = (type: PersonalizationType, formName?, items?, isSnoozed?) => {
    switch (type) {
        case PersonalizationType.SubForms:
            return getSubFormsSuggestion(formName, items, isSnoozed);
        case PersonalizationType.Actions:
            return getActionSuggestion(formName, items, isSnoozed);
        case PersonalizationType.Homepage:
            return checkEntitySuggestion(items, isSnoozed);
        default:
            return [];
    }
};

export const setNeverShowAgain = (key: string, db: any, type: PersonalizationType) => {
    if (key === actionsConf.neverAllKey) {
        sendMonitor('PersonalizationActionDontAll');
    } else if (key === formsConf.neverAllKey) {
        sendMonitor('PersonalizationSLFDontAll');
    }
    if (type === PersonalizationType.Homepage) {
        sendMonitor('PersonalizationHPDont');
    }
    neverShowAgain(type);
};

const setNeverShowAgainServer = (key: string) => {
    setStorageItem(key, 'true');
};

export const getNeverShowAgainServer = async (key: string) => {
    const item = await getStorageItem(key);
    return item?.[key] === 'true';
};

export const setNeverShowAgainByFormServer = async (formName: string, key: string) => {
    const item = await getStorageItem(key);
    const arr = item?.[key]?.split(',') || [];
    arr.push(formName);
    setStorageItem(key, arr.join(','));
};

export const getNeverShowAgainByForm = async (formName: string, key: string) => {
    const item = await getStorageItem(key);
    return item?.[key]?.split(',')?.includes(formName);
};

export const neverShowAgain = (type: PersonalizationType) => {
    switch (type) {
        case PersonalizationType.Actions:
            setNeverShowAgainServer(actionsConf.neverAllKey);
            setNeverShowAgainIndexedDB(actionsDB);
            break;
        case PersonalizationType.SubForms:
            setNeverShowAgainServer(formsConf.neverAllKey);
            setNeverShowAgainIndexedDB(subformsDB);
            break;
        case PersonalizationType.Homepage:
            setNeverShowAgainServer(homepageConf.neverAllKey);
            setNeverShowAgainIndexedDB(homepageDB);
            break;
        default:
            return;
    }
};
export const checkClearStorage = () => {
    const urlParams = window.location.search;
    if (urlParams.includes('_clearPStorage')) {
        setStorageItem(formsConf.neverFormKey, '');
        setStorageItem(formsConf.neverAllKey, '');

        setStorageItem(actionsConf.neverAllKey, '');
        setStorageItem(actionsConf.neverFormKey, '');

        setStorageItem(homepageConf.neverAllKey, '');
        setStorageItem(BLACKLIST_KEY, '');
        setStorageItem(moreInfoBlacklist, '');
        setStorageItem(PREV_INDEXED_KEY, '');

        removeNeverShowAgainIndexedDB(subformsDB);
        removeNeverShowAgainIndexedDB(actionsDB);
        removeNeverShowAgainIndexedDB(homepageDB);

        return true;
    }
    return false;
};

export const getActionsData = () => {
    const methodName = 'FormDesign';
    const reason = 'FormDesign';
    const xml = getStateXml();
    const parameters = {statexml: [xml], mode: [design.ACTIVATIONS]};
    return buildServerCall(methodName, parameters, reason, true, getConnection);
};

export const setScreensData = (fieldsXml, type: string) => {
    const methodName = 'FormDesignSet';
    const reason = 'FormDesignSet';
    const xml = getStateXml();
    const parameters = {statexml: [xml], mode: [type], xml: [fieldsXml]};
    return buildFormServerCall(methodName, parameters, reason);
};

export const getScreensData = () => {
    const methodName = 'FormDesign';
    const reason = 'FormDesign';
    const xml = getStateXml();
    const parameters = {statexml: [xml], mode: [design.SUBLEVELS]};
    return buildServerCall(methodName, parameters, reason, true, getConnection);
};

export const startNewCollectionPeriod = async () => {
    const collectionPeriodData = await getCollectionPeriodData();
    updateUserPrevIndexed(collectionPeriodData);
    updateCollectionDate(moreInfoDB);
};

export const rejectMoreInfoSuggestion = (zoomFname: string, entityId: string) => {
    addScreenToServerBlacklist(zoomFname, entityId);
};
